import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=ece2d0ee"
import script from "./adminLayout.vue?vue&type=script&lang=js"
export * from "./adminLayout.vue?vue&type=script&lang=js"
import style0 from "./adminLayout.vue?vue&type=style&index=0&id=ece2d0ee&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports